import { type UseQueryResult, useQuery } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';

const useGetFmvConfigAwardType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const OrderAwardTypeList = ['RSU', 'PSU', 'ESOP', 'ESPP'];

  const fmvConfigAwardType = useQuery(
    ['getFmvConfigAwardType'],
    async () => {
      return await handleRequest(
        FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationAwardTypesForFmvConfiguration()
      );
    },
    {
      select: (data) => {
        return data
          ?.map((item) => {
            return {
              label: item.displayName ?? '',
              value: item.id ?? '',
              systemName: item.systemName ?? '',
            };
          })
          .sort((a, b) => {
            const indexA = OrderAwardTypeList.indexOf(a.systemName);
            const indexB = OrderAwardTypeList.indexOf(b.systemName);
            return indexA - indexB;
          });
      },
    }
  );

  return fmvConfigAwardType;
};

export default useGetFmvConfigAwardType;
